import { SettingsRoutes } from 'pages/settings/route/type'
import { EmailToSmsRoutes } from './type'

const root = `${SettingsRoutes.root}/${SettingsRoutes.organization}/${EmailToSmsRoutes.root}`

export const EmailToSmsPath = {
  root: root,
}
